import { memo } from 'react';
import { EApplicantOfferPGKeys, FeeStatus } from 'api-paths-cas';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const getFeeStatus = (): string => {
    switch (cellProps.row.feeStatus) {
      case FeeStatus.Home:
        return 'Home';
      case FeeStatus.Overseas:
        return 'Overseas';
      case FeeStatus.NotSure:
        return 'Unsure';
      default:
        return UNKNOWN_VALUE;
    }
  };
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {getFeeStatus()}
    </Flex>
  );
});

export const FeeStatusColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.FEE_STATUS,
    name: 'Fee status',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
